import * as Yup from "yup";

export const YupValidations = Yup.object().shape({
  accountNumber: Yup.string()
    .min(9, "please enter a valid account number")
    .max(18, "please enter a valid account number")
    .matches(/^\d+$/, "The field should have digits only")
    .required("Field is required"),
  aadharNumber: Yup.string()
    .min(12, "please enter a valid aadhar number")
    .max(12, "please enter a valid aadhar number")
    .matches(/^\d+$/, "The field should have digits only")
    .required("Field is required"),
  gstRegistrationNumber: Yup.string()
    .min(15, "please enter a valid gst registration number")
    .max(15, "please enter a valid gst registration number"),
  bankName: Yup.string()
    .required("Field is required")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  branchName: Yup.string()
    .required("Field is required")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  ifscCode: Yup.string()
    .required("IFSC code is required")
    .min(11, "IFSC Code must be of length 11")
    .max(11, "IFSC Code must be of length 11")
    .matches(
      "^[A-Z]{4}0[0-9]{6}$",
      "First 4 characters must be alphabets,fifth character should be 0 and last 6 characters must be numbers"
    ),
  billingName: Yup.string(/^[A-Za-z ]*$/)
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
  billingNumber: Yup.string()
    .min(10, "Mobile no must be equal to 10.")
    .max(10, "Mobile no must be equal to 10.")
    .matches(/^\d+$/, "The field should have digits only"),
  payeeName: Yup.string(/^[A-Za-z ]*$/)
    .matches(/^[aA-zZ\s]+$/, "Only alphabets are allowed for this field ")
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
    panNumber: Yup.string(/^[A-Za-z ]*$/)
    .required("Field is required")
    .min(10, "pan card must be of length 10")
    .max(10, "pan card must be of length 10")
    .matches(
      /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/,
      "First 5 characters must be alphabets,four character should be numeric and last 1 characters must be alphabets.For Example:-ABCDE1234A"
    )
    .matches(/^(?!\s+$)/, "This field cannot contain only blank spaces"),
});
